import { render, staticRenderFns } from "./forestry.vue?vue&type=template&id=1f382b7b&scoped=true&"
import script from "./forestry.vue?vue&type=script&lang=js&"
export * from "./forestry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f382b7b",
  null
  
)

export default component.exports